import { ClientLookupModel, DivisionLookupModel } from "shared/request/myHealthyAdvantageApi";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ValueCallback } from "shared/core/types/callbacks";
import { ClientTypeAhead } from "../ClientTypeAhead/ClientTypeAhead";
import { Select } from "shared/UI/Select/Select";

export type ClientDivisionSelection = {
  client?: ClientLookupModel;
  division?: DivisionLookupModel;
};

type ClientDivisionSelectorProps = React.HTMLAttributes<HTMLDivElement> & {
  onSelection: ValueCallback<ClientDivisionSelection>;
  clientReadOnly?: boolean;
  initialClient?: ClientLookupModel;
  initialDivision?: DivisionLookupModel;
  divisionPlaceholder?: string;
};

export const ClientDivisionSelector = ({
  onSelection,
  clientReadOnly,
  initialClient,
  initialDivision,
  divisionPlaceholder,
}: ClientDivisionSelectorProps) => {
  const { t } = useTranslation();
  const [selectedClient, setSelectedClient] = useState<ClientLookupModel | undefined>(initialClient);
  const [selectedDivision, setSelectedDivision] = useState<DivisionLookupModel | undefined>(initialDivision);
  const divisions = selectedClient?.divisions ?? [];

  return (
    <div className="flex flex-row mb-4 justify-between">
      <ClientTypeAhead
        className="w-1/2"
        readOnly={clientReadOnly}
        onClientSelected={(client) => {
          if (clientReadOnly !== true) {
            setSelectedClient(client);
            setSelectedDivision(undefined);
            onSelection({ client, division: undefined });
          }
        }}
        initialClient={initialClient}
      />
      <div className="w-1/2 ml-4">
        <Select
          aria-label={t("clientAdminManagement.ariaDivisionFilter")}
          onChange={(e) => {
            const selectedDivision = e.target.value ? e.target.value : undefined;
            const division = divisions.find((d) => d.id === selectedDivision);
            setSelectedDivision(division);
            onSelection({ client: selectedClient, division });
          }}
          value={selectedDivision?.id || t("clientAdminManagement.divisionFilter.placeholder")}
          label={t("clientAdminManagement.divisionFilter.label")}
        >
          <option label={t("clientAdminManagement.divisionFilter.placeholder")} value={""}>{divisionPlaceholder ?? t("clientAdminManagement.divisionFilter.placeholder")}</option>
          {divisions.map((division) => (
            <option key={division.id} value={division.id}>
              {division.name}
            </option>
          ))}
        </Select>
      </div>
    </div>
  );
};
